<template>
  <main class="w-screen h-screen | overflow-x-hidden shrink-0">
    <slot />
  </main>
</template>
